/* components/ui/dom/NumberInput.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	bubble,
	detach,
	element as element_1,
	empty,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	text,
	to_number,
	toggle_class
} from "svelte/internal";

import { onMount } from "svelte";
import simpleInput from "simple-input-events";

function create_else_block(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element_1("input");
			attr(input, "title", /*value*/ ctx[0]);
			attr(input, "class", "input svelte-1guprg6");
			attr(input, "type", "number");
			attr(input, "min", /*min*/ ctx[1]);
			attr(input, "max", /*max*/ ctx[2]);
			attr(input, "step", /*step*/ ctx[3]);
			toggle_class(input, "draggable", /*draggable*/ ctx[6]);
			toggle_class(input, "fullWidth", /*fullWidth*/ ctx[5]);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			/*input_binding*/ ctx[11](input);
			set_input_value(input, /*value*/ ctx[0]);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_handler*/ ctx[9]),
					listen(input, "change", /*change_handler*/ ctx[10]),
					listen(input, "input", /*input_input_handler*/ ctx[12])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*value*/ 1) {
				attr(input, "title", /*value*/ ctx[0]);
			}

			if (dirty & /*min*/ 2) {
				attr(input, "min", /*min*/ ctx[1]);
			}

			if (dirty & /*max*/ 4) {
				attr(input, "max", /*max*/ ctx[2]);
			}

			if (dirty & /*step*/ 8) {
				attr(input, "step", /*step*/ ctx[3]);
			}

			if (dirty & /*value*/ 1 && to_number(input.value) !== /*value*/ ctx[0]) {
				set_input_value(input, /*value*/ ctx[0]);
			}

			if (dirty & /*draggable*/ 64) {
				toggle_class(input, "draggable", /*draggable*/ ctx[6]);
			}

			if (dirty & /*fullWidth*/ 32) {
				toggle_class(input, "fullWidth", /*fullWidth*/ ctx[5]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			/*input_binding*/ ctx[11](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (94:0) {#if readonly}
function create_if_block(ctx) {
	let label;
	let t;

	return {
		c() {
			label = element_1("label");
			t = text(/*value*/ ctx[0]);
			attr(label, "class", "input readonly svelte-1guprg6");
			attr(label, "title", /*value*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, label, anchor);
			append(label, t);
		},
		p(ctx, dirty) {
			if (dirty & /*value*/ 1) set_data(t, /*value*/ ctx[0]);

			if (dirty & /*value*/ 1) {
				attr(label, "title", /*value*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) detach(label);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*readonly*/ ctx[4]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { min = undefined } = $$props;
	let { max = undefined } = $$props;
	let { step = undefined } = $$props;
	let { value = undefined } = $$props;
	let { readonly = false } = $$props;
	let { round = true } = $$props;
	let { fullWidth = false } = $$props;
	let { draggable = true } = $$props;

	function roundToDecimals(value, decimals) {
		if (isNaN(value) || value === Number.NEGATIVE_INFINITY) {
			return min;
		}

		if (value === Number.POSITIVE_INFINITY) {
			return max;
		}

		return Number(value.toFixed(decimals));
	} // const dec = Number("1e-" + decimals);
	// if (value <= dec) return value;

	let element;

	onMount(() => {
		let start = null;
		let locked = false;

		const clearLock = () => {
			if (locked) {
				const fn = document.exitPointerLock || document.mozExitPointerLock;
				fn.call(document);
				locked = false;
				element.blur();
			}
		};

		let input;

		if (draggable) {
			input = simpleInput({ target: element, parent: window });

			input.on("down", ev => {
				start = [ev.event.screenX, ev.event.screenY];
			});

			input.on("up", ev => {
				clearLock();
			});

			input.on("move", ev => {
				if (ev.dragging && start && !readonly) {
					if (!locked) {
						const fn = element.requestPointerLock || element.mozRequestPointerLock;
						fn.call(element);
						locked = true;
					}

					if (ev.event.movementY != null) {
						let factor = 1;
						if (ev.event.shiftKey) factor *= 10; else if (step < 1 && (ev.event.metaKey || ev.event.ctrlKey)) factor *= 0.1;
						const pixelsToSize = ev.event.movementY * step;
						$$invalidate(0, value -= pixelsToSize * factor);
					}
				}
			});
		}

		return () => {
			if (input) input.disable();
			clearLock();
		};
	});

	function input_handler(event) {
		bubble($$self, event);
	}

	function change_handler(event) {
		bubble($$self, event);
	}

	function input_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			element = $$value;
			$$invalidate(7, element);
		});
	}

	function input_input_handler() {
		value = to_number(this.value);
		((($$invalidate(0, value), $$invalidate(1, min)), $$invalidate(2, max)), $$invalidate(8, round));
	}

	$$self.$$set = $$props => {
		if ("min" in $$props) $$invalidate(1, min = $$props.min);
		if ("max" in $$props) $$invalidate(2, max = $$props.max);
		if ("step" in $$props) $$invalidate(3, step = $$props.step);
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("readonly" in $$props) $$invalidate(4, readonly = $$props.readonly);
		if ("round" in $$props) $$invalidate(8, round = $$props.round);
		if ("fullWidth" in $$props) $$invalidate(5, fullWidth = $$props.fullWidth);
		if ("draggable" in $$props) $$invalidate(6, draggable = $$props.draggable);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*min, value, max, round*/ 263) {
			// return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
			$: {
				if (min != null && isFinite(min)) {
					$$invalidate(0, value = Math.max(value, min));
				}

				if (max != null && isFinite(max)) {
					$$invalidate(0, value = Math.min(value, max));
				}

				if (round !== false) {
					const p = round != null && isFinite(round) && typeof round === "number"
					? round
					: 5;

					$$invalidate(0, value = roundToDecimals(value, p));
				}
			}
		}
	};

	return [
		value,
		min,
		max,
		step,
		readonly,
		fullWidth,
		draggable,
		element,
		round,
		input_handler,
		change_handler,
		input_binding,
		input_input_handler
	];
}

class NumberInput extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			min: 1,
			max: 2,
			step: 3,
			value: 0,
			readonly: 4,
			round: 8,
			fullWidth: 5,
			draggable: 6
		});
	}
}

export default NumberInput;